export default {
    punchLog: 'บันทึกการเข้าออก',
    searchByEmployeeNoOrName: 'ค้นหาจากชื่อ, รหัสพนักงาน, สำนักงาน',
    search: 'ค้นหา',
    employeeId: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    bureau: 'สำนักงาน',
    image: 'รูปภาพ',
    method: 'วิธีลงเวลา',
    location: 'สถานที่',
    date: 'วันที่',
    time: 'เวลา',
    temperature: 'อุณหภูมิ',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด Excel',
    somethingWrong: 'เกิดข้อผิดพลาด'
}
